/**
 * Rota çözümlemesi — **saf fonksiyon**.
 *
 * ### ⚠️ Router kütüphanesi YOK (Rapor 14 §3.2)
 * Beş rota vardır ve geçişler tam sayfa yüklemesidir. Bir router kütüphanesi
 * kritik yola 8–15 KB ekler ve karşılığında bu ürüne hiçbir şey vermez.
 *
 * ### ⚠️ Sıra ÖNEMLİDİR
 * `/admin/usage` kontrolü `/admin` kontrolünden **önce** gelmek zorundadır;
 * tersi hâlde maliyet paneli hiçbir zaman açılmaz — `/admin/usage` de
 * `/admin` ile başlar ve yönetici konsoluna düşerdi.
 *
 * ### ⚠️ Bilinmeyen yol tanıtım sayfasına düşer
 * Cloudflare Pages, eşleşmeyen her yol için `index.html` döndürür (SPA geri
 * dönüşü). `/hakkinda` gibi bir adres bu yüzden istemciye ulaşır ve burada
 * karşılanmalıdır. Katılım sayfasına düşürmek, ziyaretçiye sebepsiz bir
 * "bağlantı geçersiz" hatası gösterirdi.
 */
export type Route = "join" | "room" | "admin" | "operator" | "usage" | "landing";

export function currentRoute(pathname: string): Route {
  if (pathname.startsWith("/room/")) return "room";
  if (pathname === "/admin/usage" || pathname.startsWith("/admin/usage/")) return "usage";
  if (pathname === "/admin" || pathname.startsWith("/admin/")) return "admin";
  /**
   * ⭐ **OPERATÖR PANELİ AYRI BİR ROTADIR** — `/admin` altında değil.
   *
   * ⚠️ `/admin/operator` gibi bir alt yol seçilseydi iki panel aynı pakette
   *    kalırdı: müşteri yöneticisinin indirdiği JS, platform ekranlarının
   *    kodunu da taşırdı. Ölü kod da indirilebilir koddur — gizlemek
   *    paketlememek değildir.
   *
   * ⚠️ Ayrı kök, ayrı Access uygulamasıyla da hizalıdır: operatör girişi
   *    kiracı uygulamasından farklı bir `aud` arkasındadır.
   */
  if (pathname === "/operator" || pathname.startsWith("/operator/")) return "operator";
  /**
   * ⚠️ `/j/` altındaki HER yol katılım sayfasına gider — kimliğin geçerli
   *    olup olmadığına bakılmaz. Bozuk bir davet bağlantısını tanıtım
   *    sayfasına düşürmek, kullanıcıya bağlantısının bozuk olduğunu hiç
   *    söylemezdi; o hatayı göstermek katılım sayfasının işidir.
   */
  if (pathname.startsWith("/j/")) return "join";
  return "landing";
}
